import LayersDrawer from 'components/maps/LayersToolbar/LayersDrawer';
import { useState, CSSProperties } from 'react';
import { LayersControlProps } from './types';
import Fab from '@mui/material/Fab';
import Layers from '@mui/icons-material/Layers';

export const LayersControl: React.FC<LayersControlProps> = ({ buttonPosition, drawerPosition }) => {
  const [isLayersOpen, setIsLayersOpen] = useState(false);

  const buttonStyle: CSSProperties = {
    position: 'absolute',
    top: buttonPosition === 'top' ? '10px' : 'unset',
    bottom: buttonPosition === 'bottom' ? '10px' : 'unset',
    right: drawerPosition === 'left' ? '10px' : 'unset',
    left: drawerPosition === 'right' ? '10px' : 'unset',
    zIndex: 2,
  };

  const toggleLayerDrawer = () => setIsLayersOpen((prev) => !prev);

  return (
    <>
      <Fab
        size='small'
        onClick={toggleLayerDrawer}
        style={buttonStyle}
        color='secondary'
        aria-label='layers'
      >
        <Layers />
      </Fab>
      <LayersDrawer withoutToolbar anchor={drawerPosition} open={isLayersOpen} />
    </>
  );
};
